import React from 'react'
import classnames from 'classnames'
import ArrowUpSmallIcon from 'components/icons/ArrowUpSmall'
import styles from './styles.css'

type Props = React.HTMLProps<HTMLDivElement> & {
  invertArrow?: boolean
  nodeRef?: React.Ref<HTMLDivElement>
}

const ButtonWithArrow: React.FC<Props> = (props) => {
  const {className, children, invertArrow, nodeRef, ...other} = props

  return (
    <div
      className={classnames(className, styles.root)}
      role="button"
      ref={nodeRef}
      {...other}>
      {children}
      <ArrowUpSmallIcon
        className={classnames(styles.icon, !invertArrow && styles.isInverted)}
      />
    </div>
  )
}

export default ButtonWithArrow
